UC.views.EnterprisePaymentsNew = Backbone.View.extend({
  initialize: function() {
    new UC.components.PaymentInfo({el: $('body')});
  }
});
